import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext<{
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  modalContent: React.ReactElement;
  setModalContent: (popup: React.ReactElement) => void;
}>({
  showModal: false,
  setShowModal: () => {},
  modalContent: {} as React.ReactElement,
  setModalContent: () => {},
});

export const useModal = () => useContext(ModalContext);

type ModalProviderProps = {
  children: React.ReactNode;
};

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [show, setShow] = useState<boolean>(false);
  const [modalContent, setModalContent] = useState<React.ReactElement>(<span />);

  const displayModal = (display: boolean) => {
    setShow(display);
  };

  const updateModalContent = (content: React.ReactElement) => {
    setModalContent(content);
  };

  return (
    <ModalContext.Provider
      value={{
        showModal: show,
        setShowModal: displayModal,
        modalContent: modalContent,
        setModalContent: updateModalContent,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
